import { ServiceTypeModel } from "../../data/entities";
import { ServiceTypeODataRepo, ServiceTypeRepo } from "../../data/repo";
import { BaseEntityService } from "../BaseEntityService"

export class ServiceTypeService extends BaseEntityService<ServiceTypeModel, ServiceTypeRepo, ServiceTypeODataRepo> {
  constructor(){
    super(new ServiceTypeRepo(), new ServiceTypeODataRepo());
  }
}

export default ServiceTypeService;
